import { render } from "./NotFoundPage.vue?vue&type=template&id=a4900fc8&ts=true"
import script from "./NotFoundPage.vue?vue&type=script&lang=ts"
export * from "./NotFoundPage.vue?vue&type=script&lang=ts"

import exportComponent from "/var/lib/jenkins/workspace/_vue_us_stage_azure_v24042026_02/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__